// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"2539950b","212":"ccd51ac3"}[chunkId] + ".chunk.css";
};